<template>
  <v-row>
    <v-col 
      cols="12" 
      sm="12" 
      md="6"
      v-for="([key, value]) in Object.entries(playmore)"
      :key="key"
    >
      <v-card 
        outlined
        tile
      >
      <v-card-title>
        <h1 class="title">{{ value.title }}</h1>
      </v-card-title>
        <v-card-text class="pb-0">
          <div class="pb-2">
            <v-img
              :src="value.img"
              height="150"
              contain
              class="grey lighten-3"
            >
              <v-row align="end" class="lightbox pa-2 fill-height">
                <v-col>
                  <div class="subheading">Main image</div>
                </v-col>
              </v-row>
            </v-img>
          </div>
          <div class="pb-2">
            <v-img
              :src="value.hover"
              height="150"
              contain
              class="grey lighten-3"
            >
              <v-row align="end" class="lightbox pa-2 fill-height">
                <v-col>
                  <div class="subheading">Hover image</div>
                </v-col>
              </v-row>
            </v-img>
          </div>
          <v-text-field
            :value="value.url"
            label="Url"
            class="pt-2"
            outlined
            disabled
            dense
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-checkbox
            v-model="value.active"
            label="active"
            class="mx-2"
            :disabled="!value.id"
            @change="(active) => setActive(value, active)"
          />
          <v-spacer /> 
          <v-btn
            color="grey darken-2"
            class="mx-2"
            text
            :disabled="!value.id"
            @click="remove(value, key)"
          >
            clear
          </v-btn>
          <PlayMoreModal
            :entity="value"
            :type="key"
            @save="save"
          />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PlayMoreModal from './PlayMoreModal';
export default {
  props: {
    title: {
      type: Object,
      required: true
    }
  },
  components: {
    PlayMoreModal
  },
  data() {
    return {
      playmore: {}
    }
  },
  created() {
    this.$axios.get('/api/title/' + this.title.title_id + '/play-more', {
      params: {
        marketplace_id: this.title.marketplace_id
      }
    })
    .then(payload => {
      this.playmore = payload.data;
    })
    .catch(err => console.warn(err.message));
  },
  methods: {
    async remove(value, key) {
      try {
        await this.$axios.delete('/api/title/' + this.title.title_id + '/play-more/' + value.id);

        this.$set(this.playmore, key, { 
          active: false,
          title: value.title,
          img: '',
          url: '',
        });

        this.$toasted.success('Image removed');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    async save(value) {
      let formData = new FormData();
      formData.set('marketplace_id', this.$route.params.id);
      formData.set('id', value.id);
      formData.set('url', value.url);
      formData.append('files', value.img_file);
      formData.append('files', value.hover_file);
      formData.set('type', value.type);
      try {
        let { data } = await this.$axios.post('/api/title/' + this.title.title_id + '/play-more', formData, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        });

        let newValue = {
          id: data.id,
          active: value.active,
          url: value.url,
          img: data.img,
          hover: data.hover,
          title: value.title
        }
        this.$set(this.playmore, 'playmore_' + value.type, newValue);
        this.$toasted.success('Image uplodaed');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    async setActive(value, active) {
      try {
        await this.$axios.put('/api/title/' + this.title.title_id + '/play-more/' + value.id, {
          active
        });

        this.$set(this.playmore, 'playmore_' + value.type, Object.assign({}, value, { active }));
        this.$toasted.success(`Image ${active ? 'activated' : 'deactivated'}`);
      } catch(err) {
        this.$toasted.error(err.message);
      }
    }
  }
}
</script>